import { render } from "./formularioSeccion.vue?vue&type=template&id=ca8bf86c&scoped=true"
const script = {}

import "./formularioSeccion.vue?vue&type=style&index=0&id=ca8bf86c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca8bf86c"]])

export default __exports__